import { ReactNode } from 'react'
import { Pane, VBox, PaneProps } from '@integration-app/ui/Layout'

import { css, cx } from 'styled-system/css'
import { BoxProps } from 'styled-system/jsx'

import { Header } from './Header'

export function ScreenWithHeader({
  leftSlot,
  rightSlot,
  paddingBlock,
  paddingInline,
  className,
  children,
  ...props
}: PaneProps & {
  leftSlot?: ReactNode
  rightSlot?: ReactNode
  paddingBlock?: BoxProps['paddingBlock']
  paddingInline?: BoxProps['paddingInline']
  className?: string
}) {
  return (
    <VBox>
      <Pane>
        <Header rightSlot={rightSlot}>{leftSlot}</Header>
      </Pane>
      <Pane
        className={cx(
          css({
            paddingBlock,
            paddingInline,
          }),
          className,
        )}
        stretch
        {...props}
      >
        {children}
      </Pane>
    </VBox>
  )
}
